import EventEmitter from 'events';
const { QWebChannel } = require('./qwebchannel');
import { bridgeEventEmitter } from './eventEmitter';

const eventsInstance = new EventEmitter();

let QTBridge: {
  selectTools: any;
  QTBackToWeb: any;
  QTToWebWithBack: any;
  QTToWeb: { connect: (arg0: (dataString: any) => void) => void };
  webToQT: (arg0: string, arg1: (res: any) => void) => void;
  webBackToQT(s: string): void;
  webToQTWithBack(s: string, param2: () => void): void;
  notification: any; //和统一桥保持一致 客户端要求统一实现  以后不再开辟新的方法
  invoke: any;
};

let _uid = 0;
export function uuid() {
  ++_uid;
  return `${new Date().getTime() + _uid}`;
}

// handleCallMap
const handleCallMap = {} as Record<string, (data: any, msgId?: string) => any>;

// 发送回调的promise闭包对象
const invokePromiseMap = {} as Record<string, (data: any) => any>;

function initQtBridge() {
  if (typeof qt === 'undefined') return;
  // eslint-disable-next-line no-new
  new QWebChannel(qt.webChannelTransport, (channel: any) => {
    // 在channel.object下，所有发布的对象在通道中都是可用的
    // 在附加的WebChannel.id属性中设置的标识符。
    QTBridge = channel.objects.qJsBridge;
    // 连接信号
    QTBridge.QTToWeb?.connect((dataString) => {
      const { eventName, data, msgId } = JSON.parse(dataString);
      eventsInstance.emit(eventName, data, msgId);
    });
    // 连接信号
    QTBridge.QTToWebWithBack?.connect((dataString: string) => {
      const { eventName, data, msgId } = JSON.parse(dataString);
      if (handleCallMap[eventName]) {
        handleCallMap[eventName](data, msgId);
      } else {
        QTBridge.webBackToQT?.(
          JSON.stringify({
            backMsgId: msgId,
            res: {
              data: {},
              code: 404,
            },
          })
        );
      }
    });
    // 连接信号
    QTBridge.QTBackToWeb?.connect((dataString: string) => {
      console.log('QTBridge.QtBackToWeb: ', dataString);
      const { backMsgId, res } = JSON.parse(dataString);
      invokePromiseMap[backMsgId]?.(res);
    });

    // 新版的统一桥
    // 获取通知
    QTBridge.notification?.connect((dataString: string) => {
      try {
        const { methodName, data, sessionId } = JSON.parse(dataString);
        if (methodName === 'callbackToWeb') {
          invokePromiseMap[sessionId]?.(data);
        } else {
          bridgeEventEmitter.emit(methodName, data, sessionId); //前端回调在被触发的方法 调用newInvoke
        }
      } catch (error) {
        console.log(error);
        throw error;
      }
    });
  });
}

initQtBridge();

export function isQTView() {
  return !!QTBridge;
}

export function invoke<T = any>(eventName: string, data: Record<string, any> = {}, timeout = 3000) {
  return new Promise<T>((resolve, reject) => {
    let done = false;
    if (QTBridge) {
      const msgId = uuid();
      console.log(`call qt msgId: ${msgId}`);
      QTBridge?.webToQTWithBack(
        JSON.stringify({
          eventName,
          data,
          msgId,
        }),
        () => {}
      );
      invokePromiseMap[msgId] = (res) => {
        const { code } = res;
        if (code === 200) {
          resolve(res);
        } else {
          reject(res);
        }
        done = true;
        delete invokePromiseMap[msgId];
      };
      setTimeout(() => {
        if (!done) {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(`bridge '${eventName}' timeout`);
          console.warn(`bridge '${eventName}' timeout`, data);
          delete invokePromiseMap[msgId];
        }
      }, timeout);
    } else {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('qtBridge不存在');
    }
  });
}

export function handle(eventName: string, callBack: (data: any) => any) {
  handleCallMap[eventName] = (data, msgId) => {
    Promise.resolve(callBack(data))
      .then((n) => {
        QTBridge.webBackToQT?.(
          JSON.stringify({
            backMsgId: msgId,
            res: {
              data: n,
              code: 200,
            },
          })
        );
      })
      .catch((err) => {
        QTBridge.webBackToQT?.(
          JSON.stringify({
            backMsgId: msgId,
            res: {
              data: err,
              code: 500,
            },
          })
        );
      });
  };
}

export interface InvokeParam<T = any> {
  methodName: string;
  params?: T;
}

interface RetProps<T> {
  status: 0 | 1;
  message: string;
  data: T;
}

// 新版的统一桥 前端调用QT客户端桥
export async function newInvoke<Param = any, Ret = any>(
  params: InvokeParam<Param>,
  timeout?: number
): Promise<Ret> {
  return new Promise<Ret>((resolve, reject) => {
    let done = false;
    if (QTBridge.invoke) {
      const sessionId = uuid();
      QTBridge.invoke(
        JSON.stringify({
          ...params,
          sessionId,
        })
      );
      invokePromiseMap[sessionId] = (res) => {
        try {
          let retData: RetProps<Ret> = {
            status: 1,
            data: {} as unknown as Ret,
            message: '',
          };
          if (typeof res === 'string') {
            retData = JSON.parse(res);
          } else {
            retData = res;
          }
          const { status, data, message } = retData;
          if (status === 1) {
            resolve(data);
          } else {
            reject(`${message}`);
          }
        } catch (error) {
          reject(res);
        }
        done = true;
        delete invokePromiseMap[sessionId];
      };
      if (timeout) {
        setTimeout(() => {
          if (!done) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject(`bridge '${params.methodName}' timeout`);
            delete invokePromiseMap[sessionId];
          }
        }, timeout);
      }
    } else {
      reject({
        status: 0,
        message: 'QTBridge.invoke is not defined',
      });
    }
  });
}
